let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("i4FRJ"), load("gbyG5"), load("87Teh")]).then(() => parcelRequire('hoY46'));